import { formatGenresToLanguages } from '@/helpers'
import {
  api,
  type ContentGenresToLanguages,
  type ContentTag,
} from '@setplex/tria-api'
import { combine, createEvent, createStore, sample } from 'effector'
import { GENRE_ALL } from '~/shared/constants'
import { resetContentOnPreferredRegionChange } from './events'
import { $languages, getContentLanguagesFx } from './languages'

export const load = createEvent()

export const getContentGenresFx = api.content.base.getContentGenresFx
export const getGenresToLanguagesFx = api.content.base.getGenresToLanguagesFx

export const $genres = createStore<ContentTag[]>([]) //
  .on(getContentGenresFx.doneData, (_, got) => {
    return [GENRE_ALL, ...(got ?? [])]
  })
  .reset(resetContentOnPreferredRegionChange)

// Store raw genres-to-languages mapping from API
export const $rawGenresToLanguages = createStore<ContentGenresToLanguages>([]) //
  .on(getGenresToLanguagesFx.doneData, (_, got) => got)
  .reset(resetContentOnPreferredRegionChange)

// Combine raw mapping with languages to create final Map
export const $genresToLanguages = combine(
  $rawGenresToLanguages,
  $languages,
  (genresToLanguages, languages) =>
    formatGenresToLanguages({
      genresToLanguages,
      languages,
    })
)

// No need to request genres if they are already loaded
// Also to prevent trigger loading on every page init (triggers on search params changes)
sample({
  clock: load,
  source: { genres: $genres, pending: getContentGenresFx.pending },
  filter: ({ genres, pending }) => !pending && !genres.length,
  fn: () => ({ withDescriptions: 1 }),
  target: getContentGenresFx,
})

sample({
  clock: load,
  source: { languages: $languages, pending: getContentLanguagesFx.pending },
  filter: ({ languages, pending }) => !pending && !languages.length,
  fn: () => ({ withDescriptions: 1 }),
  target: getContentLanguagesFx,
})

sample({
  clock: load,
  source: {
    genresToLanguages: $rawGenresToLanguages,
    pending: getGenresToLanguagesFx.pending,
  },
  filter: ({ genresToLanguages, pending }) =>
    !pending && !genresToLanguages.length,
  target: getGenresToLanguagesFx,
})
